export const MIN_SEARCH_LENGTH = 5;

export const SearchResultType = {
   CUSTOMER: "CUSTOMER",
   RESERVATION: "RESERVATION",
};

export const COMPONENT_WIDTH = 500;
